import type {TimelineEntry} from './hooks'

export type WorkingSegment =
  | {type: 'text'; content: string; stepIndex: number}
  | {
      type: 'tool'
      call: Extract<TimelineEntry, {kind: 'tool_call'}>
      result?: Extract<TimelineEntry, {kind: 'tool_result'}>
    }

/**
 * Flatten timeline entries into ordered segments for the Working strip.
 * Pairs each `tool_result` with the matching `tool_call` by `tool_call_id`, scanning
 * backwards so out-of-order results still attach to the correct call.
 */
export function buildWorkingSegments(entries: TimelineEntry[]): WorkingSegment[] {
  const out: WorkingSegment[] = []
  for (const e of entries) {
    if (e.kind === 'text') {
      out.push({type: 'text', content: e.content, stepIndex: e.step_index})
      continue
    }
    if (e.kind === 'tool_call') {
      out.push({type: 'tool', call: e})
      continue
    }
    if (e.kind === 'tool_result') {
      let attached = false
      for (let i = out.length - 1; i >= 0; i -= 1) {
        const seg = out[i]
        if (
          seg?.type === 'tool' &&
          seg.call.tool_call_id === e.tool_call_id &&
          seg.result === undefined
        ) {
          seg.result = e
          attached = true
          break
        }
      }
      if (!attached) {
        out.push({
          type: 'tool',
          call: {
            kind: 'tool_call',
            tool_call_id: e.tool_call_id,
            tool_name: e.tool_name,
            tool_input: {},
            step_index: e.step_index,
          },
          result: e,
        })
      }
    }
  }
  return out
}
